import axios from 'axios'

/**
 * Update admin profile
 * @param {Number} id Profile ID
 * @param {Object} data Form data
 * @param {String} data.email Email address
 * @param {String} [data.password] New password
 */
function update (id, data) {
  return axios
    .post(`admins/${id}/edit/`, {
      email: data.email,
      password: data.password
    })
}

export default {
  update
}
